import styled from "@emotion/styled";

export const ListContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    > .sds-card.sds-container {
        > .sds-card-body {
            overflow: unset;
            display: flex;
            flex-direction: column;
            height: 100%;
        }
    }
`;
